<template>
    <div class="jawg-map">
        <div ref="mapContainer" style="width: 100%; height: 100%"></div>
    </div>
</template>

<script>
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import Env from 'Services/Env';
import MapService from 'Services/MapService';

export default {
    props: {
        addresses: {
            type: Array,
            required: true,
        },
        selectedAddress: {
            type: Object,
            required: false,
        },
        origin: {
            type: String,
            required: false,
        },
        destination: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            addressMap: {},
            routingControl: {},
            originObject: {},
            destinationObject: {},
            routingLanguage: window.App.lang,
            jawgAccessToken: Env.get('jawg').token,
        };
    },

    mounted() {
        let self = this;
        setTimeout(() => {
            const mapContainer = self.$refs.mapContainer;
            // Init map
            if (!self.addressMap.map && mapContainer) {
                self.addressMap.map = L.map(mapContainer);
                self.addressMap.map.attributionControl.addAttribution(
                    '<a href="https://www.jawg.io" target="_blank">&copy; Jawg</a> - <a href="https://www.openstreetmap.org" target="_blank">&copy; OpenStreetMap</a>&nbsp;contributors',
                );
                L.tileLayer(MapService.getTileLayer(self.jawgAccessToken), {}).addTo(
                    self.addressMap.map,
                );

                delete L.Icon.Default.prototype._getIconUrl;

                L.Icon.Default.mergeOptions({
                    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png').default,
                    iconUrl: require('leaflet/dist/images/marker-icon.png').default,
                    shadowUrl: require('leaflet/dist/images/marker-shadow.png').default,
                });
                // Set View on selected address
                if (self.selectedAddress.lat !== null && self.selectedAddress.lng !== null)
                    self.addressMap.map.setView(
                        L.latLng(self.selectedAddress.lat, self.selectedAddress.lng),
                        12,
                    );

                // Set all marker
                for (let i = 0; i < self.addresses.length; i++) {
                    if (self.addresses[i].lat !== null && self.addresses[i].lng !== null) {
                        let content = self.addresses[i].name;
                        content += '</br>' + self.addresses[i].part1;
                        self.addresses[i].part2 != ''
                            ? (content += '</br>' + self.addresses[i].part2)
                            : '';
                        self.addresses[i].part3 != ''
                            ? (content += '</br>' + self.addresses[i].part3)
                            : '';
                        self.addresses[i].part4 != ''
                            ? (content += '</br>' + self.addresses[i].part4)
                            : '';
                        content += '</br>' + self.addresses[i].zip + ' ' + self.addresses[i].town;

                        L.marker([self.addresses[i].lat, self.addresses[i].lng])
                            .addTo(self.addressMap.map)
                            .bindPopup(content);
                    }
                }

                self.addressMap.layerGroup = L.layerGroup().addTo(self.addressMap.map);
            }
        }, 1);
    },

    methods: {
        setZoom(address) {
            this.addressMap.map.setView(L.latLng(address.lat, address.lng), 16);
        },

        startRouting() {
            let self = this;
            const provider = new OpenStreetMapProvider();

            if (this.selectedAddress.hasOwnProperty('name')) {
                this.destinationObject.x = this.selectedAddress.lng;
                this.destinationObject.y = this.selectedAddress.lat;
            } else {
                provider.search({ query: this.destination }).then((result) => {
                    if (Array.isArray(result) && result[0]) this.destinationObject = result[0];
                });
            }

            this.addressMap.map.setView(
                L.latLng(this.destinationObject.x, this.destinationObject.y),
                15,
            );

            provider.search({ query: this.origin }).then((result) => {
                if (Array.isArray(result) && result[0]) this.originObject = result[0];
                else
                    Push.error(
                        this.$l10n.__("Cette adresse n'est pas géolocalisable par nos services"),
                    );

                if (Object.keys(self.routingControl).length > 0)
                    self.addressMap.map.removeControl(self.routingControl);

                self.routingControl = L.Routing.control({
                    router: L.Routing.osrmv1({
                        serviceUrl: 'https://api.jawg.io/routing/route/v1',
                        profile: 'car',
                        requestParameters: {
                            'access-token': this.jawgAccessToken,
                        },
                        useHints: false,
                        language: this.routingLanguage,
                    }),
                    collapsible: true,
                    waypoints: [
                        L.latLng(self.originObject.y, self.originObject.x),
                        L.latLng(self.destinationObject.y, self.destinationObject.x),
                    ],
                }).addTo(self.addressMap.map);
            });
        },
    },
};
</script>

<style lang="scss">
.jawg-map {
    width: 100%;
}
</style>
